var $ = require('jquery');
var NotificationBase = require('../NotificationBase');

/* globals jimdoData, diy */
(function () {
    'use strict';
    var ExternalWebsiteImportNotification = NotificationBase.extend({
        severityDefault: 3,
        categoryDefault: 1,
        stickyDefault: 1,
        iconCls: 'ui-icon-star',
        getCssClassSuffix: function() {
            return 'ext-website-import';
        },
        content: null,
        setContent: function(c) {
            this.content = c;
        },
        getContent: function () {
            var content = '<div></div>',
                payload = this.getPayload();
            if (this.content) {
                content = this.content
            } else {
                if (payload && payload.content) {
                    content = payload.content;
                }
            }
            return $(content);
        },
        globalAction: function () {
            /**
             * make a feature check first just to be sure
             */
        },
        setIconCls: function(iconCl) {
            this.iconCls = iconCl;
        },

        getName: function() {
            return 'ExternalWebsiteImportNotification';
        }
    });
    module.exports = ExternalWebsiteImportNotification;
}());



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/notification/Notifications/ExternalWebsiteImportNotification.js
 ** module id = 660
 ** module chunks = 0
 **/